import { Navbar1 } from "components/navbars";
import { Footer1 } from "components/footer";
import Seo from "components/Seo";
import BackToTop from "components/BackToTop";

import Career from "crm/other/Career";
import { usePageTracking } from "helpers/usePageTracking";


export default function Features() {
    const seo = usePageTracking("features");
    return (
        <>
            {/* <Seo pageName="features" /> */}
            {seo && (
                <Seo
                    pageName="features"
                    title={seo.pageTitle}
                    description={seo.seoMetaDescription}
                    keywords={seo.seoMetaKeywords}
                    url="https://www.salestrackify.com/features"
                    image="/seo/trackify-preview.png"
                />
            )}

            <Navbar1
                hideSearch
                fixedWidth
                navClass="navbar-light zindex-10"
                buttonClass="btn-outline-secondary btn-sm"
            />

            <Career />
            <Footer1 />
            {/* <BackToTop /> */}
        </>
    );
}
